// extracted by mini-css-extract-plugin
export var closeButton = "_l9-1";
export var closeX = "_l9-3";
export var container = "_l9-0";
export var image = "_l9-2";